import { TYPES as createUsersActions } from './createUsersActions';

const initialState = {
  status: null,
  type: null
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case createUsersActions.CREATE_USER:
    case createUsersActions.CREATE_USER_REDIRECT:
      return {
        ...state,
        type: action.type,
        status: action.status
      };
    default:
      return state;
  }
};

export default reducers;
